export const iconFontAwesomeHalloweenWandSparkles = (
	<i className="fa-solid fa-wand-sparkles"></i>
);
